import React = require("react");
import SvgIcon from "material-ui/SvgIcon";

export class Subscript extends React.Component<__MaterialUI.SvgIconProps, {}> {
    render() {
        /* tslint:disable:max-line-length */
        return (
            <SvgIcon {...this.props}>
                <path
                    transform="translate(-0.5 0.5)"
                    fillRule="evenodd"
                    d="M15,6l-4.206,4.007L15,14l-2,2L9,12,5,16,3,14l4-4L3,6,5,4,9,8l4-4Zm7,12H19l1.512-1.693a5.7,5.7,0,0,0,.919-1.215,2.228,2.228,0,0,0,.268-1.024,2.076,2.076,0,0,0-.6-1.566,2.52,2.52,0,0,0-1.673-.5,2.672,2.672,0,0,0-1.259.291,2.491,2.491,0,0,0-.859.949,2.174,2.174,0,0,0-.3,1.131H18.4a1.222,1.222,0,0,1,.27-0.826,0.924,0.924,0,0,1,.739-0.314,0.859,0.859,0,0,1,.67.258,1.017,1.017,0,0,1,.235.71,1.355,1.355,0,0,1-.223.7,5.429,5.429,0,0,1-.687.861L17,18v1h5V18Z"
                />
            </SvgIcon>
        );
        /* tslint:enable:max-line-length */
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/svg-icons/Subscript.tsx
 **/